import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'Package', value: 'package'},
    {label: 'Hotel', value: 'hotel'},
    {label: 'Location', value: 'location'},
]

export default function SelectMappingType({...props}) {
    const myProps = {
        placeholder: 'All mapping type',
        firstSelect: true, 
        options: OPTIONS,
        icon: {icon: 'map-signs'},
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}